/**
 * Buy by the Dozen — quantity UI + live subtotal.
 * Fixes:
 *  - Price updates immediately when a variant/option is selected
 *  - Uses a per-variant price map (cents) instead of a single static data-price
 *  - Subtotal always = current variant piece price × dozens × 12
 */
document.addEventListener('DOMContentLoaded', () => {
  const wrapper = document.querySelector('.dozen-wrapper');
  if (!wrapper) return;

  let dozen = 1;
  const piecesPerDozen = 12;

  const minus = document.getElementById('minusDozen');
  const plus = document.getElementById('plusDozen');
  const input = document.getElementById('dozenCount');
  const pieces = document.getElementById('pieceCount');
  const subtotal = document.getElementById('dozenSubtotal');
  const addButton = document.getElementById('dozenAddToCart');

  // Per-variant price map from Liquid
  let variants = {};
  const mapScript = wrapper.querySelector('[data-dozen-variants]');
  if (mapScript) {
    try {
      variants = JSON.parse(mapScript.textContent);
    } catch (e) {
      console.error('[buy-by-dozen] Could not parse variant map', e);
    }
  }

  function getCurrentVariantId() {
    // Prefer the product form's master id input (kept in sync by theme JS)
    const idInput =
      document.querySelector('form[action="/cart/add"] input[name="id"]') ||
      document.querySelector('form[data-type="add-to-cart-form"] input[name="id"]') ||
      document.querySelector('product-info input[name="id"]');
    if (idInput && idInput.value) return String(idInput.value);

    // Fallback: match selected option labels against the embedded variant map
    const selected = [];
    document
      .querySelectorAll('variant-selects select option[selected], variant-selects fieldset input:checked')
      .forEach((el) => {
        selected.push(el.value);
      });
    if (selected.length) {
      const key = selected.join(' / ');
      for (const id in variants) {
        const opts = variants[id].options || [];
        if (opts.join(' / ') === key) return id;
      }
    }

    return wrapper.dataset.variantId ? String(wrapper.dataset.variantId) : Object.keys(variants)[0];
  }

  function getPiecePriceCents() {
    const id = getCurrentVariantId();
    if (id && variants[id] && typeof variants[id].price === 'number') {
      return variants[id].price;
    }
    // Last resort: data-price attribute (initial page load)
    return Number(wrapper.dataset.price) || 0;
  }

  function formatMoney(cents) {
    cents = Number(cents) || 0;
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      const fmt =
        (window.theme && theme.moneyFormat) ||
        (window.Shopify && Shopify.money_format) ||
        '{{amount}}';
      return Shopify.formatMoney(cents, fmt);
    }
    // Self-contained formatter (matches typical CAD/USD money_format)
    const amount = (cents / 100).toFixed(2);
    const withCommas = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + withCommas;
  }

  function update() {
    if (input) input.value = dozen;
    const totalPieces = dozen * piecesPerDozen;
    if (pieces) pieces.textContent = totalPieces;
    if (subtotal) {
      subtotal.textContent = formatMoney(getPiecePriceCents() * totalPieces);
    }
    // Keep data-price in sync for any other listeners
    wrapper.dataset.price = String(getPiecePriceCents());
    const id = getCurrentVariantId();
    if (id) wrapper.dataset.variantId = id;
  }

  function onVariantMaybeChanged() {
    // Resolve + repaint immediately (no network wait)
    update();
  }

  // --- Quantity steppers ---
  if (plus) {
    plus.addEventListener('click', () => {
      dozen++;
      update();
    });
  }
  if (minus) {
    minus.addEventListener('click', () => {
      if (dozen > 1) {
        dozen--;
        update();
      }
    });
  }

  // --- Variant change: fast path (option click) + authoritative path (theme pub/sub) ---
  // 1) Immediate: any change inside the variant picker
  document.addEventListener(
    'change',
    (event) => {
      if (event.target.closest('variant-selects, variant-radios, variant-picker')) {
        // Theme updates the id input after its section fetch; try now and again shortly
        onVariantMaybeChanged();
        setTimeout(onVariantMaybeChanged, 50);
        setTimeout(onVariantMaybeChanged, 300);
      }
    },
    true
  );

  // 2) Theme pub/sub when available (fires after server confirms the variant)
  try {
    if (
      typeof window.subscribe === 'function' &&
      window.PUB_SUB_EVENTS &&
      window.PUB_SUB_EVENTS.variantChange
    ) {
      window.subscribe(window.PUB_SUB_EVENTS.variantChange, (event) => {
        const variant =
          (event && event.data && event.data.variant) || (event && event.variant) || null;
        if (variant && variant.id) {
          wrapper.dataset.variantId = String(variant.id);
          if (typeof variant.price === 'number') {
            wrapper.dataset.price = String(variant.price);
          }
        }
        update();
      });
    }
  } catch (e) {
    /* ignore */
  }

  // 3) Watch the hidden variant id input (updated by theme after fetch)
  const idInput =
    document.querySelector('form[action="/cart/add"] input[name="id"]') ||
    document.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
  if (idInput) {
    idInput.addEventListener('change', onVariantMaybeChanged);
    // MutationObserver covers cases where value is set without a change event
    const mo = new MutationObserver(onVariantMaybeChanged);
    mo.observe(idInput, { attributes: true, attributeFilter: ['value'] });
  }

  // --- Add to cart ---
  if (addButton) {
    addButton.addEventListener('click', () => {
      const variantInput =
        document.querySelector('form[action="/cart/add"] input[name="id"]') ||
        document.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');

      if (!variantInput || !variantInput.value) {
        alert('Variant not found');
        return;
      }

      const variantID = variantInput.value;
      const qty = dozen * piecesPerDozen;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantID, quantity: qty }),
      })
        .then((r) => r.json())
        .then(() => {
          alert('Added ' + qty + ' pieces to cart');
          location.reload();
        })
        .catch(() => {
          alert('Something went wrong');
        });
    });
  }

  update();
});